import HTTP from "../../http";

const PAYMENT_ENDPOINT = "/payments";
const STRIPE_ACCOUNT_LINK_ENDPOINT = "/user/stripeAccountLink";

const STRIPE_CONNECT_RETURN_URL =
  "http://localhost:8080/profile?connectReturn=1";
const STRIPE_CONNECT_REFRESH_URL =
  "http://localhost:8080/profile?connectRefresh=1";

export async function createStripeAccountLink() {
  return await HTTP.post(
    PAYMENT_ENDPOINT + STRIPE_ACCOUNT_LINK_ENDPOINT,
    {
      returnUrl: STRIPE_CONNECT_RETURN_URL,
      refreshUrl: STRIPE_CONNECT_REFRESH_URL
    },
    {
      headers: { "Content-Type": "application/json" }
    }
  );
}
